export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'annual-crop-production';
export const REPORT_APE_ID = 'annual-crop-production-ape';
export const SLIDE_NUMBER = 9;
